const state = {
  version: '0.1.0',
  userPreferences: { theme: { name: '' } },
  undocounter: 0,
  searchQuery: '',
  activeTags: [],
  languages: [
    {
      id: 'kaxwmhv8',
      name: 'javascript',
      isSelected: true,
      snippets: [
        {
          id: 'kaxwmhva',
          name: 'a beautiful new snippet',
          isSelected: true,
          code: 'your awesome new code',
          description: 'snipp snipp',
          tags: [],
          timeStamp: 1591101286390,
        },
      ],
      isInEditMode: false,
    },
  ],
  tags: [],
};
export default state;
